import * as actionType from './action-type'
import initialState from './initial-state'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionType.SET_LOGIN_ACCOUNT:
      return {
        ...state,
        user: payload.user
      }
    default:
      return state
  }
}
